// @flow

import * as React from 'react';

import styles from './FeaturedVenueIcon.scss';

export default function FeaturedVenueIcon(): React.Node {
  return (
    <div className={styles.icon}>
      <svg
        height="28"
        width="28"
        viewBox="0 0 30 30"
        preserveAspectRatio="xMinYMin meet"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>{__('search.venue_preview.featured')}</title>
        <g fill="none" fillRule="evenodd" stroke="#fff" strokeLinejoin="round">
          <path
            d="M15 29.414L28.99 8.629l-6.435-7.252H7.444L1.01 8.63z"
            fill="#32be9c"
            strokeOpacity=".898"
            strokeWidth="2"
          />
          <g strokeLinecap="round" strokeOpacity=".503">
            <path d="M27.727 8.803l-5.622-6.426H15V8.75z" fill="#2ba285" />
            <path d="M2.273 8.803l5.622-6.426H15V8.75z" fill="#5ed4b8" />
            <path d="M10.606 2.377L8.212 8.803H15V2.377z" fill="#33c29f" />
            <path d="M19.243 2.377l2.545 6.426H15V2.377z" fill="#30b594" />
            <path d="M21.363 8.803L15 27.623l12.727-18.82z" fill="#248971" />
            <path d="M8.636 8.803L15 27.623 2.273 8.803z" fill="#2fb292" />
            <path d="M15 8.803v18.82L8.212 8.803z" fill="#2eae8f" />
            <path d="M15 8.803v18.82l6.788-18.82z" fill="#27957b" />
          </g>
        </g>
      </svg>
    </div>
  );
}
